<template>
  <div>
    <el-table :data="tableData" border style="width: 100%">

      <el-table-column prop="name" label="姓名" width="120">
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="100">
        <template slot-scope="scope">
          <el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button>
          <el-button type="text" size="small">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  import {

  } from '@/api/xgcApi'
  export default {
    components: {

    },
    filters: {},
    data() {
      return {
        form: {
          tableData:[]
        },

      }
    },
    computed: {},
    created() {},

    mounted() {
      this.getList()
    },
    methods: {},
  }
</script>

<style scoped>

</style>
